module.exports = __webpack_public_path__ + "static/media/gallery_07.5132811f.png";